<section class="page">
  <header class="page__header">
    <div>
      <h1>Tagebuch</h1>
      <p>Fortlaufende tägliche Empfindungen und Gedanken.</p>
    </div>
    <button type="button" class="secondary" (click)="loadEntries()">Aktualisieren</button>
  </header>

  <section class="card daily-journal">
    <div class="daily-journal__form">
      <label>
        Datum
        <input type="date" [(ngModel)]="entryDate" [ngModelOptions]="{standalone: true}" />
      </label>
      <label class="daily-journal__text">
        Eintrag
        <textarea
          rows="5"
          [(ngModel)]="entryText"
          [ngModelOptions]="{standalone: true}"
          placeholder="Wie fühlst du dich heute? Was nimmst du wahr?"
        ></textarea>
      </label>
      <button type="button" class="primary" (click)="addEntry()" [disabled]="!entryDate || !entryText.trim()">Eintrag speichern</button>
    </div>
    <p class="error-text" *ngIf="errorMessage">{{ errorMessage }}</p>
  </section>

  <section class="daily-journal__timeline" *ngIf="groups().length; else noEntries">
    <section class="daily-journal__day" *ngFor="let group of groups()">
      <h2>{{ group.date }}</h2>
      <article class="daily-journal__entry" *ngFor="let item of group.entries">
        <p>{{ item.entryText }}</p>
        <div>
          <span>{{ item.createdAt || '' }}</span>
        </div>
      </article>
    </section>
  </section>

  <ng-template #noEntries>
    <p class="empty">Noch keine Tagebuch-Einträge vorhanden.</p>
  </ng-template>
</section>
